import { orderBy } from "lodash";

import { type CreateBudgetRecommendationRunResultStatusGQLEnum } from "@north-beam/nb-client-side";

import { type ClientSetting } from "../types";

export function getClientSettingLatestBudgetGenerationResult(
  clientSetting: ClientSetting,
): CreateBudgetRecommendationRunResultStatusGQLEnum | null {
  const hasRunResults =
    clientSetting.createBudgetRecommendationRunResults &&
    clientSetting.createBudgetRecommendationRunResults.length > 0;

  if (!hasRunResults) {
    return null;
  }

  const latestRunResult = orderBy(
    clientSetting.createBudgetRecommendationRunResults,
    "modified",
    "desc",
  )[0];

  return latestRunResult.status;
}
